import { StyleSheet, Text, View } from '@react-pdf/renderer';
import * as React from 'react';

const styles = StyleSheet.create({
  cell: {
    fontFamily: 'OpenSans',
    borderStyle: 'solid',
    borderColor: 'black',
    borderWidth: 1,
    paddingHorizontal: 5,
    paddingVertical: 1,
  },
  text: {
    fontFamily: 'OpenSans',
    fontSize: 9,
    paddingBottom: 2,
  },
  row: {
    flexDirection: 'row',
  },
});

const HeaderBoletinesPdf = ({ entidades, seccion, estudiante }) => {
  return (
    <View>
      <View style={styles.row}>
        <View
          style={[
            styles.cell,
            {
              borderRightWidth: 0,
              borderBottomWidth: 0,
              width: '50%',
              padding: 5,
            },
          ]}
        >
          <Text style={styles.text}>REPUBLICA BOLIVARIANA DE VENEZUELA</Text>
          <Text style={styles.text}>
            MINISTERIO DEL PODER POPULAR PARA LA EDUCACION
          </Text>
          <Text style={styles.text}>
            {(entidades.activo.nombre ?? entidades.activo.entidad.nombre)
              .toString()
              .toUpperCase()}
          </Text>
        </View>
        <View
          style={[
            styles.cell,
            {
              borderBottomWidth: 0,
              width: '50%',
              padding: 5,
            },
          ]}
        >
          <Text style={styles.text}>BOLETIN RENDIMIENTO ESTUDIANTIL</Text>
          <View
            style={{
              ...styles.row,
              justifyContent: 'flex-start',
            }}
          >
            <Text style={{ ...styles.text, fontWeight: 700 }}>
              AÑO ESCOLAR:{' '}
            </Text>
            <Text style={styles.text}>
              {entidades.ajustes.periodoAcademico.desde}{' '}
              {entidades.ajustes.periodoAcademico.hasta} (
              {entidades.ajustes.periodoAcademico.nombre})
            </Text>
          </View>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <View style={styles.row}>
              <Text style={{ ...styles.text, fontWeight: 700 }}>CURSO: </Text>
              <Text style={styles.text}>
                {seccion.nivelAcademico.nivelAcademico.nombre}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={{ ...styles.text, fontWeight: 700 }}>SECCION: </Text>
              <Text style={styles.text}>{seccion.nombre}</Text>
            </View>
            <View style={styles.row}>
              <Text style={{ ...styles.text, fontWeight: 700 }}>TURNO: </Text>
              <Text style={styles.text}>{seccion.turno}</Text>
            </View>
          </View>
        </View>
      </View>
      <View style={styles.row}>
        <View
          style={{
            ...styles.cell,
            ...styles.row,
            borderRightWidth: 0,
            width: '25%',
          }}
        >
          <Text style={{ ...styles.text, fontWeight: 700 }}>CÉDULA: </Text>
          <Text style={{ ...styles.text }}>{estudiante.perfil.dni}</Text>
        </View>
        <View
          style={{
            ...styles.cell,
            ...styles.row,
            borderRightWidth: 0,
            width: '60%',
          }}
        >
          <Text style={{ ...styles.text, fontWeight: 700 }}>
            NOMBRES Y APELLIDOS:{' '}
          </Text>
          <Text style={{ ...styles.text }}>
            {estudiante.perfil.pnombre} {estudiante.perfil.snombre}{' '}
            {estudiante.perfil.papellido} {estudiante.perfil.sapellido}
          </Text>
        </View>
        <View
          style={{
            ...styles.cell,
            ...styles.row,
            width: '15%',
          }}
        >
          <Text style={{ ...styles.text, fontWeight: 700 }}>GÉNERO: </Text>
          <Text style={{ ...styles.text }}>{estudiante.perfil.genero}</Text>
        </View>
      </View>
    </View>
  );
};

export default HeaderBoletinesPdf;
